import $ = require("jquery");
window['$'] = window['jQuery'] = $;
import 'jqueryui';
